import * as Types from '../constants/actionTypes';

const defaultState = {
    pendingAssets: [],
    pendingBOMs: [],
    pendingParts: [],

    approvedAssets: [],
    approvedBOMs: [],
    approvedParts: [],

    rejectedAssets: [],
    rejectedBOMs: [],
    rejectedParts: [],

    pendingAssetError: '',
    pendingBOMError: '',
    pendingPartError: '',

    approvedAssetError: '',
    approvedBOMError: '',
    approvedPartError: '',

    rejectedAssetError: '',
    rejectedBOMError: '',
    rejectedPartError: '',

    siteNames: [],
    siteNamesErr: '',

    selected: null,
    currentTab: {
        AssetType: 0,
        PartMaintenance: 0,
    }
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.SYNCING_BOM_MAINTENANCE_LIST:
            return {
                ...state,
                bomMaintenanceList: action.list
            }
        case Types.SYNCING_BOM_MAINTENANCE_LIST_FAIL:
            return {
                ...state,
                bomMaintenanceList: [],
                bomMaintenanceListError: 'Got Error while get request list',
            }
        case Types.SYNCING_INSTANCES_LIST:
            return {
                ...state,
                syncInstancesList: action.list.data,
                syncInstancesListCount: action.list.count
            }
        case Types.SYNCING_INSTANCES_LIST_FAIL:
            return {
                ...state,
                syncInstancesList: [],
                syncInstancesListError: 'Got Error while get request list',
            }
        case Types.SINGLE_INSTANCE_DETAILS:
            return {
                ...state,
                syncSingleInstanceDetails: action.list
            }
        case Types.SINGLE_INSTANCE_DETAILS_FAIL:
            return {
                ...state,
                syncSingleInstanceDetails: [],
                syncSingleInstanceDetailsError: 'Got Error while get request list',
            }
        case Types.SYNCING_PENDING_BOM_LIST:
            return {
                ...state,
                pendingBOMs: action.list
            }
        case Types.SYNCING_PENDING_BOM_LIST_FAIL:
            return {
                ...state,
                pendingBOMs: [],
                pendingBOMError: 'Got Error while get request list',
            }
        case Types.SYNCING_PENDING_PART_LIST:
            return {
                ...state,
                pendingParts: action.list
            }
        case Types.SYNCING_PENDING_PART_LIST_FAIL:
            return {
                ...state,
                pendingParts: [],
                pendingPartError: 'Got Error while get request list',
            }
        //////////////////////////////////

        case Types.SYNCING_ASSET_TYPE_LIST:
            return {
                ...state,
                syncAssetTypeList: action.list.data,
                syncAssetTypeListColumns: action.list.columns,
                syncAssetTypeListCount: action.list.counts
            }
        case Types.SYNCING_ASSET_TYPE_LIST_FAIL:
            return {
                ...state,
                syncAssetTypeList: [],
                syncAssetTypeListColumns: [],
                syncAssetTypeListError: 'Got Error while get request list',
            }
        case Types.SYNCING_PART_MAINTENANCE_LIST:
            return {

                ...state,

                syncPartMaintenanceList: action.list.data,
                syncPartMaintenanceColumns: action.list.columns,
                syncPartMaintenanceListCount: action.list.counts
            }
        case Types.SYNCING_PART_MAINTENANCE_LIST_FAIL:
            return {
                ...state,
                syncPartMaintenanceList: [],
                syncPartMaintenanceColumns: [],
                syncPartMaintenanceListError: 'Got Error while get request list',
            }
        case Types.SYNCING_ASSET_TYPE_DETAILS:
            return {
                ...state,
                syncSingleAssetTypeDetails: action.list
            }
        case Types.SET_SYNC_STATUS:
            return {
                ...state,
                AssetTypeSyncStatus: action.status
            }

        case Types.SYNCING_ASSET_TYPE_DETAILS_FAIL:
            return {
                ...state,
                syncSingleAssetTypeDetails: [],
                syncSingleAssetTypeDetailsError: 'Got Error while get request list',
            }

        case Types.SYNCING_PART_MAINTENANCE_DETAILS:
            return {
                ...state,
                syncSinglePartMaintenanceDetails: action.list
            }
        case Types.SYNCING_PART_MAINTENANCE_DETAILS_FAIL:
            return {
                ...state,
                syncSingleAssetTypeDetails: [],
                syncSingleAssetTypeDetailsError: 'Got Error while get request list',
            }
        case Types.SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS:
            return {
                ...state,
                getPartsByAssetTypes: action.list.data,
                getPartsByAssetTypesCount: action.list.totalCount
            }
        case Types.SYNCING_PART_MAINTENANCE_ASSET_TYPE_DETAILS_FAIL:
            return {
                ...state,
                getPartsByAssetTypes: [],
                getPartsByAssetTypesError: 'Got Error while get request list',
            }


        case Types.SYNCING_APPROVED_BOM_LIST:
            return {
                ...state,
                approvedBOMs: action.list
            }
        case Types.SYNCING_APPROVED_BOM_LIST_FAIL:
            return {
                ...state,
                approvedBOMs: [],
                approvedBOMError: 'Got Error while get request list',
            }
        case Types.SYNCING_APPROVED_PART_LIST:
            return {
                ...state,
                approvedParts: action.list
            }
        case Types.SYNCING_APPROVED_PART_LIST_FAIL:
            return {
                ...state,
                approvedParts: [],
                approvedPartError: 'Got Error while get request list',
            }
        //////////////////////////////////////

        case Types.REJECT_ASSET_TYPE_DETAILS_SUCCESS:
            return {
                ...state,
                rejectedAssets: action.data
            }
        case Types.REJECT_ASSET_TYPE_DETAILS_FAILED:
            return {
                ...state,
                rejectedAssets: [],
                rejectedAssetError: 'Got Error while get request list',
            }
        case Types.REJECT_PART_MAINTENANCE_DETAILS_SUCCESS:
            return {
                ...state,
                rejectedPartMaintenanceDetails: action.data
            }
        case Types.REJECT_PART_MAINTENANCE_DETAILS_FAILED:
            return {
                ...state,
                rejectedPartMaintenanceDetails: [],
                rejectedPartMaintenanceDetailsError: 'Got Error while get request list',
            }
        case Types.LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS_SUCCESS:
            return {
                ...state,
                lockedorUnlockedAssets: action.data
            }
        case Types.LOCK_OR_UNLOCK_ASSET_TYPE_DETAILS_FAILED:
            return {
                ...state,
                lockedorUnlockedAssets: [],
                lockedorUnlockedAssetsError: 'Got Error while get request list',
            }
        case Types.LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_SUCCESS:
            return {
                ...state,
                lockedorUnlockedPartMaintenance: action.data
            }
        case Types.LOCK_OR_UNLOCK_PART_MAINTENANCE_DETAILS_FAILED:
            return {
                ...state,
                lockedorUnlockedPartMaintenance: [],
                lockedorUnlockedPartMaintenanceError: 'Got Error while get request list',
            }
        case Types.SYNCING_REJECTED_BOM_LIST:
            return {
                ...state,
                rejectedBOMs: action.list
            }
        case Types.SYNCING_REJECTED_BOM_LIST_FAIL:
            return {
                ...state,
                rejectedBOMs: [],
                rejectedBOMError: 'Got Error while get request list',
            }
        case Types.SYNCING_REJECTED_PART_LIST:
            return {
                ...state,
                rejectedParts: action.list
            }
        case Types.SYNCING_REJECTED_PART_LIST_FAIL:
            return {
                ...state,
                rejectedParts: [],
                rejectedPartError: 'Got Error while get request list',
            }
        /////////////////////////////////
        case Types.SYNCING_DETAIL:
            return {
                ...state,
                selected: action.data
            }
        case Types.SYNCING_DETAIL_FAIL:
            return {
                ...state,
                selected: null,
                error: 'Got Error while get request detail',
            }
        ////////////////////////////////
        case Types.SITE_NAME:
            return {
                ...state,
                siteNames: action.list
            }
        case Types.SITE_NAME_FAIL:
            return {
                ...state,
                siteNames: [],
                siteNamesErr: 'Got Error while get request list',
            }
        case Types.SYNCING_WASTE_NUMBERS_LIST_SUCCESS:
            return {
                ...state,
                wasteNumbersList: action.list
            }
        case Types.SYNCING_WASTE_NUMBERS_LIST_FAILED:
            return {
                ...state,
                wasteNumbersList: [],
                wasteNumbersListErr: 'Got Error while get request list',
            }

        case Types.MASTER_ASSET_TYPE_BY_ID:
            return {
                ...state,
                masterAssetTypeDoc: action.list
            }
        case Types.MASTER_ASSET_TYPE_BY_ID_ERROR:
            return {
                ...state,
                masterAssetTypeDoc: [],
                masterAssetTypeErr: 'Got Error while get master asset type document',
            }
        case Types.MASTER_PART_BY_ID:
            return {
                ...state,
                masterPartDoc: action.list
            }
        case Types.MASTER_PART_BY_ID_ERROR:
            return {
                ...state,
                masterPartDoc: [],
                masterPartDocError: 'Got Error while get Master part document',
            }

        case Types.SYNCING_ASSET_TYPE_APPROVE_DETAILS:
            return {
                ...state,
                approveDetails: action.data
            }
        case Types.SYNCING_ASSET_TYPE_APPROVE_DETAILS_FAIL:
            return {
                ...state,
                approveDetails: [],
                approveDetailsError: 'Got Error while approving request',
            }
        case Types.SYNCING_PART_MAINTENANCE_APPROVE_DETAILS:
            return {
                ...state,
                approveDetails: action.data
            }
        case Types.SYNCING_PART_MAINTENANCE_APPROVE_DETAILS_FAIL:
            return {
                ...state,
                approveDetails: [],
                approveDetailsError: 'Got Error while approving request',
            }
        case Types.SYNCING_ASSET_TYPE_EDIT_DETAILS:
            return {
                ...state,
                editDetails: action.data
            }
        case Types.SYNCING_ASSET_TYPE_EDIT_DETAILS_FAIL:
            return {
                ...state,
                editDetails: [],
                editDetailsEror: 'Got Error while edit approve',
            }
        case Types.SYNCING_PART_MAINTENANCE_EDIT_DETAILS:
            return {
                ...state,
                editDetails: action.data
            }
        case Types.SYNCING_PART_MAINTENANCE_EDIT_DETAILS_FAIL:
            return {
                ...state,
                editDetails: [],
                editDetailsEror: 'Got Error while edit approve',
            }
        case Types.SYNCING_ADMIN_EMAIL:
            return {
                ...state,
                adminEmail: action.data
            }
        case Types.SYNCING_ADMIN_EMAIL_UPDATE:
            return {
                ...state,
                adminEmail: action.data
            }
        case Types.SYNCING_ADMIN_EMAIL_FAIL:
            return {
                ...state,
                adminEmail: null,
                error: 'Got Error while get admin email config',
            }
        case Types.SYNCING_SET_TAB:
            let currentTab = state.currentTab;
            currentTab[action.model] = action.tab;
            return {
                ...state,
                currentTab,
            }

        default:
            return state
    }
}
